const avatarColors = [
  'from-blue-400 to-blue-600',
  'from-purple-400 to-purple-600',
  'from-green-400 to-green-600',
  'from-orange-400 to-orange-600',
  'from-pink-400 to-pink-600',
  'from-indigo-400 to-indigo-600',
  'from-teal-400 to-teal-600',
  'from-red-400 to-red-600',
  'from-yellow-400 to-yellow-600',
  'from-cyan-400 to-cyan-600',
  'from-emerald-400 to-emerald-600',
  'from-violet-400 to-violet-600',
]

/**
 * Get consistent avatar gradient color based on a string (typically email).
 * Returns a Tailwind gradient class string.
 */
export function getAvatarColor(identifier: string | undefined): string {
  const str = identifier || 'default'
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i)
    hash = hash & hash // Convert to 32-bit integer
  }
  return avatarColors[Math.abs(hash) % avatarColors.length]
}

/**
 * Get user initials for avatar fallback.
 */
export function getInitials(firstName: string, lastName: string): string {
  const first = firstName?.charAt(0) || ''
  const last = lastName?.charAt(0) || ''
  return `${first}${last}`.toUpperCase() || 'U'
}
